import React from 'react';
import { connect } from "react-redux";
import createProvider from '../../../API/Provider/AddProvider'
import { BsBackspaceFill } from 'react-icons/bs'
import { store } from 'react-notifications-component';
import { withRouter } from 'react-router-dom';
import Loader from './../../../Global/loader'
import Select from 'react-select'
import GetCountries from './../../../API/Provider/GetProviderCountries'
import { withNamespaces } from 'react-i18next';
import { Row, Col, Form, Button } from 'react-bootstrap'

class CreateProvider extends React.Component {
  
    state={
        full_name: '',
        email: '',
        phone_number: '',
        countriesList: [],
        countries: [],
      
        company_address: '',
        company_place: '',
        company_postal_code: '',
        company_legal_ID: '',
        company_VAT_ID: '',
        in_VAT: true,
      

        premisess_label: '',
        terminal_label: '',
        sequence_marker:''
    }

    componentDidMount = async () => {
        const { t } = this.props
        document.title = t('Create Client')

        let data = {
            activePage: 1,
            pageSize: 1000,
            search:{
                searchFor: ""
            },
            sortBy: {id: 0},
            sortDirection: 0,
            activeOnly: "Active"
        }

        //get countries
        let items = await GetCountries(data)       
        let countryList = []
        
        await items.data.countries
            .map((data, index) =>{
            let oneItem = {value: data.uuid , label: data.country_name }
            countryList.push(oneItem)
            return null
        })
            
        await this.setState({
            countriesList: countryList,
            countries: [countryList[0]]
        })

        await this.setState({
            loading: false            
        })
    }

    handleChange(e){
        let value = e.target.value
        this.setState({
            [e.target.id]: value === "on" ? !this.state[e.target.id] : value
        })  
    }

    handleCountryChange(e){
        this.setState({
            countries: e
        })                  
    }


    addNewProvider = async (e) => {
        const { t } = this.props
        e.preventDefault()
        this.setState({ loading: true })
        
        let createResponse = await createProvider(this.state) 
        if(createResponse.data.status !== 201){
            store.addNotification({
                title: this.props.t('Error!'),
                message: t('An error occurred while creating provider, please try again'),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({ loading: false })
        }
        else{        
            await store.addNotification({
                title: "Uspjeh!",
                message: t('Creating provider was a success'),
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })

            this.setState({
                full_name: '',
                email: '',
                phone_number: '',
                countries: []
            })  


            this.props.goBack()
            //this.props.history.push("/providers")            

        }
    }

    handlePdv = async () => {
        this.setState({
            in_VAT: !this.state.in_VAT
        })
    } 

    render(){  
        const { t } = this.props

        return (
            <>                
                <header>
                    <h3>
                        {t('Creating Provider')}
                    </h3>
                    <hr/>
                </header>

                {this.state.loading ?
                    <Loader />
                :
                <>
                    <Form className="form-container">
                        <Row>  
                            <Col sm={12} md={12} xl={6}>
                            <Form.Group as={Row} className="mb-3">
                                    <Form.Label htmlFor="full_name" column sm={2} md={4}>{t('Full Name')}<span className="color-red">*</span></Form.Label>
                                    <Col sm={10} md={8}>
                                        <Form.Control        
                                            id="full_name"                          
                                            type="text"
                                            value={this.state.full_name}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </Col>
                                </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                    <Form.Label htmlFor="phone_number" className="col-4  col-form-label">{t('Phone Number')}<span className="color-red">*</span></Form.Label>
                                    <Col sm={10} md={8}>
                                        <Form.Control
                                            id="phone_number"  
                                            type="text"
                                            value={this.state.phone_number}
                                            onChange={e => this.handleChange(e)}                                        
                                        />
                                    </Col>
                                </Form.Group>
                            
                            <Form.Group as={Row} className="mb-3">
                                    <Form.Label htmlFor="unitOfMeasure" column sm={2} md={4}>{t('OIB')}<span className="color-red">*</span></Form.Label>
                                    <Col sm={10} md={8}>
                                        <Form.Control
                                            label="company_legal_ID" 
                                            id="company_legal_ID" 
                                            type="text"
                                            minLength={11}
                                            maxLength={11}
                                            onChange={(e) => this.handleChange(e)}
                                            //isValid={this.state.oibPassed}
                                            value={this.state.company_legal_ID}
                                        />
                                    </Col>
                                </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                    <Form.Label htmlFor="country" column sm={2} md={4}>{t('Countries')}<span className="color-red">*</span></Form.Label>
                                    <Col sm={10} md={8}>
                                        <Select
                                            isMulti
                                            options={this.state.countriesList} 
                                            onChange={(values) => this.handleCountryChange(values)}
                                            isClearable
                                            isInvalid={this.state.countries === null}
                                            value={this.state.countries}
                                        />
                                    </Col>
                                </Form.Group>
                    

                            <Form.Group as={Row} className="mb-3">
                                    <Form.Label htmlFor="in_vat_system" column sm={2} md={4}>{t('PDV')}</Form.Label>
                                    <Col sm="10" md="8">
                                        <Form.Label className="checbox-form-label p-2" htmlFor="gridCheck2">
                                            <input    
                                                id="in_vat_system"                       
                                                type="checkbox"
                                                checked={this.state.in_vat_system}
                                                onChange={e => this.handleChange(e)}
                                            />
                                            
                                            &nbsp;&nbsp; {t('in the VAT system')}
                                        </Form.Label>
                                    </Col>
                                </Form.Group>

                            </Col>

                            <Col className="col-12 col-md-12 col-xl-6 ">

                            <Form.Group as={Row} className="mb-3">
                                    <Form.Label htmlFor="email" column sm={2} md={4}>{t('Email')}<span className="color-red">*</span></Form.Label>
                                    <Col sm={10} md={8}>
                                        <Form.Control
                                            id="email"  
                                            type="text"
                                            value={this.state.email}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </Col>
                                </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                    <Form.Label htmlFor="company_address" className="col-4  col-form-label">{t('Address')}<span className="color-red">*</span></Form.Label>
                                    <Col sm={10} md={8}>
                                        <Form.Control
                                            id="company_address"  
                                            type="text"
                                            value={this.state.company_address}
                                            onChange={e => this.handleChange(e)}                                        
                                        />
                                    </Col>
                                </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                    <Form.Label htmlFor="company_place" className="col-4  col-form-label">{t('Company place')}<span className="color-red">*</span></Form.Label>
                                    <Col sm={10} md={8}>
                                        <Form.Control
                                            id="company_place"  
                                            type="text"
                                            value={this.state.company_place}
                                            onChange={e => this.handleChange(e)}                                        
                                        />
                                    </Col>
                                </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                    <Form.Label htmlFor="company_postal_code" className="col-4  col-form-label">{t('Company postal code')}<span className="color-red">*</span></Form.Label>
                                    <Col sm={10} md={8}>
                                        <Form.Control
                                            id="company_postal_code"  
                                            type="text"
                                            value={this.state.company_postal_code}
                                            onChange={e => this.handleChange(e)}                                        
                                        />
                                    </Col>
                                </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                    <Form.Label htmlFor="premisess_label" column sm={2} md={4}>{t('Premisess Label')}<span className="color-red">*</span></Form.Label>
                                    <Col sm={10} md={8}>
                                        <Form.Control
                                            id="premisess_label"  
                                            type="text"
                                            value={this.state.premisess_label}
                                            onChange={e => this.handleChange(e)}                                        
                                        />
                                    </Col>
                                </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                    <Form.Label htmlFor="temrinal_label" column sm={2} md={4}>{t('Terminal Label')}<span className="color-red">*</span></Form.Label>
                                    <Col sm={10} md={8}>
                                        <Form.Control
                                            id="terminal_label"  
                                            type="text"
                                            value={this.state.terminal_label}
                                            onChange={e => this.handleChange(e)}                                        
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        
                        <Form.Group as={Row} className="mb-3">
                            <Col sm={12} className="button-container text-center">
                                <Button    
                                    variant='spremi'
                                    onClick={(e) => this.addNewProvider(e)}
                                    className="btnSpremi" 
                                >
                                    {t('Save')}
                                </Button>
                            </Col>
                        </Form.Group>
                    </Form>

                    <div className="form-group mt-5">
                        <div
                            className="btn btn-default mb-2"
                            onClick={() => this.props.goBack()}                       
                        > 
                            <BsBackspaceFill size={30} />  
                            <strong> {t('Back')} </strong>
                        </div> 
                    </div>  
                </>
                }
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(CreateProvider)));


